import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ClaimformService } from '../claimform.service';
import { ClaimRouterService } from '../claim-router.service';

@Component({
  selector: 'app-modal-consent',
  templateUrl: './modal-consent.component.html',
  styleUrl: './modal-consent.component.css'
})
export class ModalConsentComponent {
    constructor(
    public modalRef: BsModalRef,
    private claimRouterService: ClaimRouterService,
    public claimformService: ClaimformService
  ) { }


  closeModal(){
    this.modalRef.hide();
  }

  acceptConsentAndCloseModal(){
    this.claimformService.acceptCDCConsent();
    this.closeModal();
  }

  declineConsentAndCloseModal(){
    this.closeModal();
    this.claimRouterService.routeToConsentWithdrawn();
  }

  ngOnInit() {
  }
}
